import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Demo from "@/pages/Demo";
import DemoUB04 from "@/pages/DemoUB04";
import DemoADADental from "@/pages/DemoADADental";
import DemoInsuranceEnrollment from "@/pages/DemoInsuranceEnrollment";
import CMS1500 from "@/pages/CMS1500";
import CMS1450 from "@/pages/CMS1450";
import ADAJ430D from "@/pages/ADAJ430D";
import FormOCR from "@/pages/FormOCR";
import EnrollmentFormOCR from "@/pages/EnrollmentFormOCR";
import NPIValidator from "@/pages/NPIValidator";
import FakeNPIGenerator from "@/pages/FakeNPIGenerator";
import FakePatientGenerator from "@/pages/FakePatientGenerator";
import Synthetic837 from "@/pages/Synthetic837";
import ToolsIndex from "@/pages/ToolsIndex";
import NPILookupByName from "@/pages/NPILookupByName";
import CMS1500Fields from "@/pages/CMS1500Fields";
import BlogCMS1500ParsingRCM from "@/pages/BlogCMS1500ParsingRCM";
import PaperToEDI from "@/pages/PaperToEDI";
import PaperTo835 from "@/pages/PaperTo835";
import TryUpload from "@/pages/TryUpload";
import Contact from "@/pages/Contact";
import Enterprise from "@/pages/Enterprise";
import AboutUs from "@/pages/AboutUs";
import ContactUs from "@/pages/ContactUs";
import Admin from "@/pages/Admin";
import { PrivacyPolicy, Terms, Refund } from "@/pages/Legal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/try" element={<TryUpload />} />
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="demo/hcfa-cms-1500" element={<Demo />} />
            <Route path="demo/ub-04-cms-1450" element={<DemoUB04 />} />
            <Route path="demo/ada-dental" element={<DemoADADental />} />
            <Route path="demo/insurance-enrollment" element={<DemoInsuranceEnrollment />} />
            <Route path="demo" element={<Navigate to="/demo/hcfa-cms-1500" replace />} />
            <Route path="cms-1500-ocr" element={<CMS1500 />} />
            <Route path="cms-1450-ocr" element={<CMS1450 />} />
            <Route path="ada-j430d-ocr" element={<ADAJ430D />} />
            <Route path="form-ocr" element={<FormOCR />} />
            <Route path="enrollment-form-ocr" element={<EnrollmentFormOCR />} />
            <Route path="tools" element={<ToolsIndex />} />
            <Route path="tools/npi-validator" element={<NPIValidator />} />
            <Route path="tools/fake-npi-generator" element={<FakeNPIGenerator />} />
            <Route path="tools/fake-patient-generator" element={<FakePatientGenerator />} />
            <Route path="tools/payer-specific-synthetic-837" element={<Synthetic837 />} />
            <Route path="tools/npi-lookup-by-name" element={<NPILookupByName />} />
            <Route path="resources/cms-1500-claim-form-boxes-list" element={<CMS1500Fields />} />
            <Route
              path="blog/who-offers-cms-1500-parsing-tools-for-revenue-cycle-operations"
              element={<BlogCMS1500ParsingRCM />}
            />
            <Route path="paper-to-edi-service" element={<PaperToEDI />} />
            <Route path="paper-to-835" element={<PaperTo835 />} />
            <Route path="contact-sales" element={<Contact />} />
            <Route path="enterprise" element={<Enterprise />} />
            <Route path="about-us" element={<AboutUs />} />
            <Route path="contact-us" element={<ContactUs />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="tnc" element={<Terms />} />
            <Route path="refund" element={<Refund />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
